import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"

import { cn } from '~/utils/commonUtils'

function RadioGroup({
  className,
  ...props
}) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid gap-3", className)}
      {...props} />
  );
}

function RadioGroupItem({
  className,
  ...props
}) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        // EDS radio (Figma: EasyLlama Brand System › Radio): 20px, white with a grey-4 border, purple with a 10px white dot when selected.
        "flex aspect-square size-5 shrink-0 cursor-pointer items-center justify-center rounded-full border border-llama-grey-4 bg-llama-grey-1 outline-none transition-colors duration-200",
        "hover:bg-llama-grey-9 data-[state=checked]:border-[5px] data-[state=checked]:border-llama-purple-4 data-[state=checked]:bg-llama-purple-4 data-[state=checked]:hover:border-llama-purple-3 data-[state=checked]:hover:bg-llama-purple-3",
        "focus-visible:ring-2 focus-visible:ring-llama-grey-4 focus-visible:ring-offset-1 data-[state=checked]:focus-visible:ring-llama-purple-4",
        "disabled:cursor-not-allowed disabled:border-llama-grey-8 disabled:bg-llama-grey-8 disabled:data-[state=checked]:border-llama-grey-8 disabled:data-[state=checked]:bg-llama-grey-8 aria-invalid:border-destructive",
        className
      )}
      {...props}>
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex items-center justify-center">
        <span className="size-2.5 shrink-0 rounded-full bg-llama-grey-1" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem }
